/**
 * Task Details Time field Names
 * @type {Readonly<{id: string, assignmentNumber: string, task: string, clockIn: string, clockOut: string, selectedDate: string, totalHours: string, comment: string}>}
 */
const taskDetailsTimeFieldName = Object.freeze({
  id: "id",
  assignmentNumber: "assignmentNumber",
  task: "task",
  clockIn: "clockIn",
  clockOut: "clockOut",
  selectedDate: "selectedDate",
  totalHours: "totalHours",
  comment: "comment"
});

/**
 *  Task Details Time field Text
 * @type {Readonly<{id: string, assignmentNumber: string, task: string, clockIn: string, clockOut: string, selectedDate: string, totalHours: string, comment: string}>}
 */
const taskDetailsTimeFieldText = Object.freeze({
  id: "ID",
  assignmentNumber: "Assignment",
  task: "Task",
  clockIn: "Clock In",
  clockOut: "Clock Out",
  selectedDate: "Selected Date",
  totalHours: "Total Hours",
  comment: "Comment"
});

export { taskDetailsTimeFieldName, taskDetailsTimeFieldText };
